import type { datadogLogs, Logger } from '@datadog/browser-logs';

declare global {
  interface Window {
    datadogLogs: typeof datadogLogs;
  }
}

const LOGGER_NAME = 'error-metrics';
const LOGGER_KIND = 'browser-metrics';

function createDatadogErrorLogger(): Logger | undefined {
  const logger = window?.datadogLogs?.createLogger(LOGGER_NAME, {});
  logger?.addContext('kind', LOGGER_KIND);

  return logger;
}

export const ddErrorLogger = createDatadogErrorLogger();
